export function TotalMoneyIcon({
  className = "size-5",
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_2663_29964)">
        <path d="M7.08329 12.2216C7.08329 13.2955 7.95385 14.166 9.02774 14.166H10.8333C11.9839 14.166 12.9166 13.2333 12.9166 12.0827C12.9166 10.9321 11.9839 9.99935 10.8333 9.99935H9.16663C8.01603 9.99935 7.08329 9.06661 7.08329 7.91602C7.08329 6.76542 8.01603 5.83268 9.16663 5.83268H10.9722C12.0461 5.83268 12.9166 6.70324 12.9166 7.77713M9.99996 4.58268V5.83268M9.99996 14.166V15.416M18.3333 9.99935C18.3333 14.6017 14.6023 18.3327 9.99996 18.3327C5.39759 18.3327 1.66663 14.6017 1.66663 9.99935C1.66663 5.39698 5.39759 1.66602 9.99996 1.66602C14.6023 1.66602 18.3333 5.39698 18.3333 9.99935Z" stroke="#101828" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_2663_29964">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export const displayName = "TotalMoneyIcon";
